import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '../components/profile/ProfilePage';

export const Route = createFileRoute('/profile/$identifier')({
  component: function PublicProfileRoute() {
    const { identifier } = Route.useParams();
    return <ProfilePage identifier={identifier} />;
  },
});
